export enum RegistrationType {
	PAID = 'Paid',
	FREE = 'Free',
	TRIAL = 'Trial',
}
